<template>
  <div class="RwvContentEmbed">
    <b-embed
      type="iframe"
      :aspect="data.ratio"
      :src="data.src"
      allowfullscreen
    ></b-embed>
  </div>
</template>

<script>

export default {
  name: "RwvContentEmbed",
  props: {
    data: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  }
};
</script>
